import * as React from 'react'

import { observer } from 'mobx-react'

import NotificationDetailsViewStore from '~/client/src/desktop/views/NotificationDetails/NotificationDetailsView.store'
import { HeaderBar } from '~/client/src/shared/components/HeaderBar'
import {
  Content,
  Footer,
  Header,
  View,
} from '~/client/src/shared/components/Layout'

interface INotificationDetailsBaseProps {
  store?: NotificationDetailsViewStore
  backClicked?: () => void
  title?: React.ReactNode
  content: React.ReactNode
  footer?: React.ReactNode
  viewChild?: React.ReactNode
}

const NotificationDetailsBase: React.FC<INotificationDetailsBaseProps> = ({
  backClicked,
  title,
  content,
  footer,
  viewChild,
}) => {
  const renderHeader = () => {
    if (!title) {
      return null
    }

    return (
      <HeaderBar>
        <img
          className="no-grow pr20"
          src="/static/icons/back-arrow.svg"
          alt="BACK"
          onClick={backClicked}
        />
        {title}
      </HeaderBar>
    )
  }

  return (
    <View>
      <Header>{renderHeader()}</Header>
      {viewChild}
      <Content scrollable={true}>{content}</Content>
      <Footer>{footer}</Footer>
    </View>
  )
}

export default observer(NotificationDetailsBase)
